import { render, staticRenderFns } from "./SnitchPanel.vue?vue&type=template&id=d52d31a8&scoped=true&"
import script from "./SnitchPanel.vue?vue&type=script&lang=js&"
export * from "./SnitchPanel.vue?vue&type=script&lang=js&"
import style0 from "./SnitchPanel.vue?vue&type=style&index=0&id=d52d31a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52d31a8",
  null
  
)

export default component.exports